import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Button, Container, Icon, theme } from '@sweetgreen/garnish';

import { useCustomer } from '@order/Customer';
import { useLocalizationContext } from '@order/Localization';

import { useScanToPayFeatureFlag } from '../../../ScanToPayScreen/ScanToPay.featureFlag';

type Props = {
  readonly isLoggedIn: boolean;
  readonly onPressScanToPay?: () => void;
};

export const MobileHeader = (props: Props) => {
  const { isLoggedIn = false, onPressScanToPay } = props;
  const { t } = useLocalizationContext();

  const { customer } = useCustomer();
  const isScanToPayEnabled = useScanToPayFeatureFlag();

  const label = !isScanToPayEnabled
    ? t('home.scan-to-pay-disabled')
    : t('home.scan-to-pay');

  return (
    <View testID="home.mobile-header">
      <Container style={styles.row}>
        {isLoggedIn && customer.qrCode ? (
          <View>
            <Button
              testID="home.scan-to-pay.button"
              palette="secondary"
              size="xsmall"
              disabled={!isScanToPayEnabled}
              accessibilityRole="link"
              accessibilityLabel={label}
              accessibilityHint={label}
              onPress={onPressScanToPay}
            >
              {label}
            </Button>
          </View>
        ) : (
          <Icon
            name="IconSweetgreen"
            color={theme.colors.KALE}
            width={40}
            height={40}
          />
        )}
      </Container>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: 56,
  },
});
